<template>
  <div>
    <div class="echart_zonglan">
      <div class="echarts_font">
        <img :src="icon_font" class="icon_img" alt="" />
        <span class="people_font">全县奶牛产业总统计</span>
      </div>
      <div id="echart_farming_two"></div>
    </div>
    <div class="companySelect">
      <div class="echarts_font">
        <img :src="icon_font" class="icon_img" alt="" />
        <span class="people_font">奶牛示范企业</span>
      </div>
      <div>
        <span class="selectLable">企业名称:</span>
        <el-select v-model="value" :popper-append-to-body="false"  @change="getId()">
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.companyName"
            :value="item.companyId"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="companyBox">
      <!-- 切换按钮 -->
      <div class="compantBtn">
        <div class="btnBox">
          <div
            v-for="(item, index) in menuList"
            :key="index"
            :class="[isActive == index ? 'activeBtn' : 'btn']"
            @click="selectIndustry(index)"
          >
            <p class="btnTitle">{{ item.title }}</p>
          </div>
        </div>
      </div>
      <div v-if="this.isActive == 0">
        <Menu1 :introduction="introduction" :imgList="photoUrls"  :videoshow="videoshow" :propaganda="videoUrls"></Menu1>
      </div>
      <div v-if="this.isActive == 1">
        <Menu2 :photoUrls="photoUrls"></Menu2>
      </div>
      <div v-if="this.isActive == 2">
        <Menu3 :honorUrls="honorUrls"></Menu3>
      </div>
      <div v-if="this.isActive == 3">
        <Menu4 :productList="companyProductInfoList"></Menu4>
      </div>
      <div v-if="this.isActive == 4">
        <Menu5 :videoList="companyVideoInfoList"></Menu5>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import Menu1 from "./companyInformation/menu1.vue";
import Menu2 from "./companyInformation/menu2.vue";
import Menu3 from "./companyInformation/menu3.vue";
import Menu4 from "./companyInformation/menu4.vue";
import Menu5 from "./companyInformation/menu5.vue";
export default {
  components: {
    Menu1,
    Menu2,
    Menu3,
    Menu4,
    Menu5
  },
  data() {
    return {
      icon_font: require("@/assets/images/icon_font.png"),
      // 奶产业接口数据
      twoAowNumberList: [],
      twoMilkNumberList: [],
      twoCowInMilkNumberList: [],
      twoTheYear: [],
      options: [],
      value: "",
      menuList: [
        { title: "企业简介" },
        { title: "企业相册" },
        { title: "资质荣誉" },
        { title: "企业产品" },
        { title: "视频监控" },
      ],
      isActive: 0,
      // 企业简介
      introduction:'',
      // 产品信息集合
      companyProductInfoList: [],
      // 监控信息集合
      companyVideoInfoList: [],
      // 荣誉资质地址集合
      honorUrls: [],
      // 企业相册地址集合
      photoUrls: [],
      // 宣传片地址集合
      videoUrls:[],
      // 是否显示宣传视频
      videoshow:true,
    };
  },
  created() {
    this.getCompantList();
    this.value = this.options[0].companyId;
    this.isActive=0;
  },
  mounted() {
    this.init_two();
     this.$nextTick(function () {
      this.getCompanyInformation();
    });
  },
  methods: {
    // 奶产业
    init_two() {
      // 调取数据
      var data_nai = plOtherDataInterface.getCowFiveYearList();
      var cowNumberList = data_nai.cowNumberList;
      var milkNumberList = data_nai.milkNumberList;
      var cowInMilkNumberList = data_nai.cowInMilkNumberList;
      this.twoAowNumberList = milkNumberList.map((item) => item.theNumber);
      this.twoMilkNumberList = cowNumberList.map((item) => item.theNumber);
      this.twoCowInMilkNumberList = cowInMilkNumberList.map(
        (item) => item.theNumber
      );
      this.twoTheYear = milkNumberList.map((item) => item.theYear);

      var myChart = echarts.init(document.getElementById("echart_farming_two"));
      var option = {
        color: ["#FADB7D", "#FA7D7D", "#00BAFF"],
        tooltip: {
          trigger: "axis",
          // axisPointer: {
          //   type: "cross",
          // },
          formatter: (params) => {
            const items = Array.isArray(params) ? params : [params];
            const safeItems = items.filter(p => p && p.seriesName !== undefined && p.data !== undefined);
            if (!safeItems.length) return '';
            const lines = safeItems.map(p => {
              const unit = p.seriesName === '奶产量' ? '万吨' : '万头';
              return `<div style="font-size:12px;">${p.seriesName}:${p.data}${unit}</div>`;
            });
            return lines.join('');
          },
        },
        grid: {
          top: '15%',
          bottom: '18%',
          left: '8%',
          right: '6%'
        },
        legend: {
          data: [
            { name: "奶牛存栏量", textStyle: { color: "#fff" ,fontSize:16} },
            { name: "泌乳牛存栏量", textStyle: { color: "#fff",fontSize:16 } },
            { name: "奶产量", textStyle: { color: "#fff",fontSize:16 } },
          ],
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: "#ccc",
                width: 1,
                type: "dashed",
              },
            },
            data: this.twoTheYear,
          },
        ],
        yAxis: [
          {
            name: "单位(万)",
            // 修改Y轴：单位（万人样式）
            nameTextStyle: {
              color: "#fff",
            },
            type: "value",
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: "#ccc",
                width: 1,
                type: "dashed",
              },
            },
          },
          {
            name: "奶产量/单位（万吨）",
            show: false,
            type: "value",
            axisLabel: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: false
            }
          },
        ],
        series: [
          {
            name: "奶牛存栏量",
            type: "line",
            smooth: false,
            yAxisIndex: 0,
            label: {
              show: true,
              position: "top",
              color: "#fff",
              distance: 6
            },
            data: this.twoMilkNumberList,
          },
          {
            name: "泌乳牛存栏量",
            type: "line",
            smooth: false,
            showSymbol: true,
            emphasis: { focus: "series" },
            yAxisIndex: 0,
            label: {
              show: true,
              position: "bottom",
              color: "#fff",
              distance: 6
            },
            data: this.twoCowInMilkNumberList,
          },
          {
            name: "奶产量",
            type: "line",
            smooth: false,
            showSymbol: true,
            lineStyle: { type: "dashed" },
            emphasis: { focus: "series" },
            yAxisIndex: 0,
            label: {
              show: true,
              position: "top",
              color: "#fff",
              distance: 6
            },
            data: this.twoAowNumberList,
          },
        ],
      };
      option && myChart.setOption(option);
    },
    // 选择产业
    selectIndustry(index) {
      this.isActive = index;     
    }, 
    getCompantList() {
      var data_Company = plOtherDataInterface.getCompanyList(2);
      this.options = data_Company;
    },
    getCompanyInformation() {
      var Information = plOtherDataInterface.getCompanyDetailsById(this.value);
      this.introduction=Information.introduction;
      this.videoUrls = Information.videoUrls;
      this.photoUrls = Information.photoUrls;
      this.honorUrls = Information.honorUrls;
      this.companyProductInfoList = Information.companyProductInfoList;
      this.companyVideoInfoList = Information.companyVideoInfoList;
            if (this.videoUrls  == undefined || this.videoUrls.length <= 0) {
        this.videoshow=false;
      } else {
        this.videoshow=true;
      }
    },
    getId(){
      this.getCompanyInformation()
    }
  },
};
</script>

<style lang="less" scoped>
.echart_zonglan {
  margin: 1.875rem 0 0 0;
  border-bottom: 1px dashed rgb(121, 226, 154);
  padding-top: 1.875rem;
}

#echart_farming_two{
  height: 18.75rem;
}
.echarts_font {
  text-align: left;
}
.icon_img {
  width: 25px;
  height: 25px;
  margin-right: 0.4375rem;
  vertical-align: sub;
}
.people_font {
  font-size: 24px;
  color: rgb(62, 248, 156);
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #d3d3d3;
}
::-webkit-scrollbar {
  background-color: #15606e;
  width: 5px;
} /* 这是针对缺省样式 (必须的) */
::-webkit-scrollbar-thumb {
  background: #00574a;
  width: 5px;
  border-radius: 10px;
} /* 滑块颜色 */

.companySelect {
  padding-top: 1rem;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
// 下拉选择框样式
.selectLable {
  width: 90px;
  height: 25px;
  font-size: 16px;
  font-family: PingFang-SC-Medium;
  text-align: center;
  color: #ffffff;
  line-height: 18px;
  margin-right: 5px;
}
.el-select {
  width: 151px;
  border-radius: 4px;
}
.el-select,
/deep/ .el-input,
/deep/ .el-input__inner {
  background: rgba(138, 206, 254, 0.3);
  text-align: center;
  color: ghostwhite;
  font-size: 16px;
  height: 30px;
}
.el-select /deep/ .el-select-dropdown__item.selected {
  color: rgb(62, 248, 156);
}
.el-select /deep/ .el-select__caret {
  /*很关键：将默认的select选择框样式清除*/
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  /*为下拉小箭头留出一点位置，避免被文字覆盖*/
  /*自定义图片*/
  background: url("../../../assets/icon/selectIcon.png") no-repeat scroll right
    center transparent;
  /*自定义图片的大小*/
  background-size: 12px 12px;
}
/*将小箭头的样式去去掉*/
.el-select /deep/ .el-icon-arrow-up:before {
  content: "";
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.companyBox {
  margin-top: 25px;
  padding: 0 25px;
  background-color: #104853;
  border: 1px solid #008f82;
}
.btnBox {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  margin: 28px 0;
  border-bottom: 1px solid rgb(121, 226, 154);
  padding-bottom: 15px;
  justify-content: space-around;
}
.btn {
  width: 140px;
  height: 30px;
  background: rgba(18, 87, 123, 0.6);
  border: 1px solid #00ffce;
  text-align: center;
  cursor: pointer;
}
.activeBtn {
  width: 140px;
  height: 30px;
  background: linear-gradient(0deg, #2dbcdd, #09809c 78%, #2dbcdd);
  border: 1px solid #00ffff;
  text-align: center;
  cursor: pointer;
}
.btnTitle {
  font-size: 16px;
  font-family: inpinheiti;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftAside/digital_industry/cow.vue